import { Link } from "@shopify/hydrogen";
import { useState, useRef } from 'react';
import { getCountryCodeFromUrl } from '~/lib/utils'

export function LightUpChochin(props) {
  const [isLitUp, setIsLitUp] = useState<boolean>(false);
  const ref = useRef<HTMLVideoElement>(null)

  return (
    <li><Link to={props.link}>
      <div
        onMouseEnter={()=>{
          ref.current!.play()
          setIsLitUp(true)
        }}
        onMouseLeave={()=>{
          setIsLitUp(false)
        }}
        className="pconly"
      >
        <video
          src={props.videoA}
          muted
          preload="auto"
          className="shown"
          ref={ref}
          poster={props.poster}
        ></video>
        {!isLitUp && <video
          src={props.videoB}
          muted
          autoPlay
          preload="auto"
          className="shown"
        ></video>}
      </div>
      <div className="sponly">
        <img src={props.poster}></img>
      </div>
      <div>{getCountryCodeFromUrl() === "jp" ? props.titleJa :props.title}</div>{/*<div>{props.price}JPY</div> */}
    </Link></li>
  )
}